// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2iPIY","notes":"Notes_notes__1JwzY","note":"Notes_note__29Uda","markdown":"Notes_markdown__-arOG"};